import styled from "styled-components"
import { CopyContainer } from 'components/common'

export const CopyContainerStyled = styled(CopyContainer)`
  margin-top: 12px;
`